// removed by extract-text-webpack-plugin
module.exports = {"new-resource-set-button":"style__new-resource-set-button___1lVZg","resource-actions":"style__resource-actions___9Z7kZ","resource-action":"style__resource-action___1imzb","resource-pack-icon":"style__resource-pack-icon___39s2j","resource-details":"style__resource-details___2zIhB","resource-pack":"style__resource-pack___1Z8t0","resource-file-number":"style__resource-file-number___3zdvQ","pack-to-delete":"style__pack-to-delete___1TO2h"};


//////////////////
// WEBPACK FOOTER
// ./components/ResourceList/style.scss
// module id = 1325
// module chunks = 0